/** The "Trial Payroll Preview Only" banner from the Figma. Shown whenever the server says the host is not Production. */
export function TrialBanner() {
  return (
    <div className="wc-trial" role="note" data-testid="trial-banner">
      <span className="wc-trial__icon" aria-hidden="true">!</span>
      <div>
        <strong>Trial Payroll Preview Only</strong>
        <p>
          You can review and preview payments, but this will not submit live payroll, initiate direct deposit, or file/pay taxes until your
          account is fully activated.
        </p>
      </div>
    </div>
  );
}

/** Honest replacement for the Figma delivery promise: no check printing or mailing exists in this release. */
export function CheckDeliveryNote() {
  return (
    <div className="wc-advisory" role="note" data-testid="check-delivery-note">
      <span aria-hidden="true">✉</span>
      <span>
        Check printing and mailing are not enabled in this release. Approving this batch records the approval only — no check is printed,
        mailed or delivered.
      </span>
    </div>
  );
}
